/**
 * Мост «холст → панель» для загрузки файла: пустой экран на холсте принимает
 * файл (перетаскиванием или кликом), а грузит его зона загрузки в панели блока —
 * с её правами, прогрессом и записью в черновик. Своего загрузчика у холста нет
 * намеренно: второй путь записи разошёлся бы с панелью. Прогресс идёт обратно:
 * панель грузит, холст показывает полосу. Одна загрузка за раз — зона одна.
 */
export const createUploadBridge = () => {
  type Listener = (file: File | null) => void
  const listeners = new Set<Listener>()
  const removeListeners = new Set<() => void>()
  let progress: number | null = null
  const progressListeners = new Set<() => void>()

  return {
    /** `file === null` — открыть выбор файла в панели. */
    request: (file: File | null): void => listeners.forEach((l) => l(file)),
    onRequest: (listener: Listener): (() => void) => {
      listeners.add(listener)
      return () => {
        listeners.delete(listener)
      }
    },
    /** Снять файл: запись в черновик — тоже дело зоны в панели. */
    requestRemove: (): void => removeListeners.forEach((l) => l()),
    onRemoveRequest: (listener: () => void): (() => void) => {
      removeListeners.add(listener)
      return () => {
        removeListeners.delete(listener)
      }
    },
    setProgress: (next: number | null): void => {
      progress = next
      progressListeners.forEach((l) => l())
    },
    subscribeProgress: (listener: () => void): (() => void) => {
      progressListeners.add(listener)
      return () => {
        progressListeners.delete(listener)
      }
    },
    getProgress: (): number | null => progress,
  }
}

export type UploadBridge = ReturnType<typeof createUploadBridge>

/** Картинка блока «Картинка» (info). */
export const imageUploadBridge = createUploadBridge()
